module.exports = __webpack_public_path__ + "img/pencil-edit.9104b90b.svg";